import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Typography } from '@material-ui/core';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  header: { margin: '10px', minHeight: '40px' },
  action: { textTransform: 'none' },
}));

const EventTableHeader = ({ selectEverything, title, data, selected, pageSize }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const unreadCount = _.filter(data, (event) => {
    return !event.read_at;
  }).length;
  const readCount = _.filter(data, (event) => {
    return !!event.read_at;
  }).length;
  const eventInfo = ` - ${unreadCount} Unread - ${readCount} Read`;

  const markedCount = selected.length;
  return (
    <div>
      <Grid container spacing={1} alignItems="center" direction="row" className={classes.header}>
        <Grid item>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        {!(unreadCount === 0 && readCount === 0) && (
          <Grid item>
            <Typography>{eventInfo}</Typography>
          </Grid>
        )}
        {!(unreadCount === 0 && readCount === 0) && (
          <Grid item>
            {(markedCount === pageSize || markedCount === data.length) && (
              <Button onClick={selectEverything} color="primary">
                <Typography className={classes.action}>
                  {markedCount === data.length
                    ? t('clear_selection')
                    : t('you_selected') + `${markedCount}` + t('select_all') + `${data.length}` + t('events_question')}
                </Typography>
              </Button>
            )}
          </Grid>
        )}
      </Grid>
    </div>
  );
};

EventTableHeader.propTypes = {
  selectEverything: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.array,
  selected: PropTypes.array,
  pageSize: PropTypes.number,
};

EventTableHeader.defaultProps = {
  selectEverything: () => {},
  title: '',
  info: [],
  selected: [],
  pageSize: 0,
};

export default EventTableHeader;
